import { LitElement, html } from 'vendor/lit'
import { getSection, getSectionId, imagesLoaded } from 'utils/gw'
// TODO: REWORK THIS TO JUST USE A GENERIC TOOLTIP COMPONENT
class HHProductSiblings extends LitElement {
  constructor() {
    super()

    this.productSiblings = this.querySelectorAll('[data-swatch]')
    this.tooltipContainer = this.querySelector('.swatches__tooltip')
    this.section = getSection(this)
    this.sectionId = getSectionId(this)

    this.onSwatchClick = this.onSwatchClick.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    // this.addEventListener('click', this.onSwatchClick)
    this.productSiblings.forEach(sibling => {
      sibling.addEventListener('mouseenter', this.onHoverTooltip.bind(this))
      sibling.addEventListener('mouseleave', this.onHoverTooltip.bind(this, true))
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    // this.removeEventListener('click', this.onSwatchClick)
  }

  async onSwatchClick(e) {
    e.preventDefault()
    e.stopPropagation()

    const swatch = e.target.closest('[data-swatch]')

    if (!swatch) return

    // const swatch = e.target
    // const productId = swatch.dataset.productId
    // const variantId = swatch.dataset.variantId
    console.log('CLICKED', swatch)

    // TODO: Adjust logic to replace specific portions of the section
    // TODO: -> Media / Content region separately
    // TODO: Alternatively, mark each color-specific chunk of markup and replace those from fetched version!
    try {
      const url = swatch.href
      console.log('SWATCH URL', url)
      const response = await fetch(`${url}?section_id=${this.sectionId}`)
      const markup = await response.text()
      // console.log('MARKUP', markup)

      const parser = new DOMParser()
      const doc = parser.parseFromString(markup, 'text/html')
      console.log('DOC SECTION', doc.querySelector('.shopify-section'))

      await imagesLoaded(doc.querySelector('.shopify-section'), { container: true })
      this.section.replaceWith(doc.querySelector('.shopify-section'))
      // this.section.outerHTML = markup
    } catch (error) {
      console.error('ERROR', error)
    }
  }

  onHoverTooltip(e, close = false) {
    if (close) {
      this.tooltipContainer.style.top = ''
      this.tooltipContainer.style.left = ''
      this.tooltipContainer.innerHTML = ''
      this.tooltipContainer.classList.remove('is-hovered')
      return
    }

    e.preventDefault()
    const el = e.target
    const content = el.dataset.tooltip ?? el.dataset.swatch

    if (content === null) return
    this.tooltipContainer.innerHTML = content
    this.tooltipContainer.style.top = `${el.offsetHeight + el.offsetTop + 10}px`
    this.tooltipContainer.style.left = `${el.offsetLeft + el.offsetWidth / 2}px`
    this.tooltipContainer.classList.add('is-hovered')
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-siblings', HHProductSiblings)
